import React from 'react';
import styles from './index.module.scss';

const Period = ({ fromDate, toDate }) => {
  return (
    <div className={styles.root}>
      <div className={styles.date}>{fromDate}</div> —{' '}
      <div className={styles.date}>{toDate}</div>
    </div>
  );
};

export default Period;
